<template>
  <!-- :id="link.indexOf('/activity/guardhunter') == -1?'app':'appAct'" -->
  <div
    :id="link.indexOf('/activity/guardhh') == -1 ? 'app' : 'appAct'"
    :style="
      !isWeiXin &&
      link.indexOf('account') == -1 &&
      link != '/' &&
      link.indexOf('/activity') == -1 &&
      link.indexOf('/acts') == -1 &&
      link.indexOf('/yearReport') == -1 &&
      link.indexOf('/reportInfo') == -1 &&
      link.indexOf('/reportCustomer') == -1 &&
      link.indexOf('/reportTrace') == -1 &&
      link.indexOf('/reportTraceDetail') == -1
        ? 'padding-top:55px;'
        : ''
    "
  >
    <!-- showApp jssdk加载完成以后才可以访问app -->
    <!-- && link.indexOf('/activity') == -1 本地的活动页面 单独的 -- acts(新) -->
    <router-view v-if="showApp" />
    <div
      id="fixed-unwx-bar"
      v-if="
        !isWeiXin &&
          link.indexOf('account') == -1 &&
          link.indexOf('/activity') == -1 &&
          link.indexOf('/acts') == -1 &&
          link != '/' &&
          link.indexOf('yearReport') == -1 &&
          link.indexOf('/reportInfo') == -1 &&
          link.indexOf('/reportCustomer') == -1 &&
          link.indexOf('/reportTrace') == -1 &&
          link.indexOf('/reportTraceDetail') == -1
      "
      class="fxied-unwx-wrap"
    >
      <ul class="fixed-unwx">
        <li style="border-right:1px solid #fafafa" @click="showMenu1 = true">
          猎上职位
        </li>
        <li style="border-left:1px solid #fafafa" @click="showMenu2 = true">
          用户中心
        </li>
      </ul>
      <van-popup v-model="showMenu1" position="top">
        <div class="pop-list-area">
          <p
            v-for="(item, index) in actions1"
            :key="index"
            @click="onSelect(item)"
          >
            {{ item.name }}
          </p>
        </div>
      </van-popup>

      <van-popup v-model="showMenu2" position="top">
        <div class="pop-list-area">
          <p
            v-for="(item, index) in actions2"
            :key="index"
            @click="onSelect(item)"
          >
            {{ item.name }}
          </p>
        </div>
      </van-popup>
      <!-- <van-action-sheet v-model="showMenu1" :round="false" :actions="actions1" @select="onSelect" />
      <van-action-sheet v-model="showMenu2" :round="false" :actions="actions2" @select="onSelect" /> -->
    </div>
  </div>
</template>

<style src="@/common/styles/common.scss" lang="scss"></style>

<style lang="scss" scoped>
.fxied-unwx-wrap {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1002;
  .pop-list-area {
    width: 100%;
    p {
      height: 50px;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      background-color: #fff;
      border-bottom: 1px solid #f1f1f1;
    }
  }
}

.fixed-unwx {
  height: 45px;
  line-height: 45px;
  background: #fff;
  display: flex;

  border-top: 1px solid #fafafa;
  box-shadow: 0px -1px 5px #555;

  li {
    flex: auto;
    text-align: center;
  }
}
</style>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import { Toast } from "vant";
import { authorize } from "@/api/app";

export default {
  name: "app-main-module",
  data() {
    return {
      isWeiXin: true,
      showMenu1: false,
      link: this.$route.path || "/",
      actions1: [
        {
          name: "成单易",
          path: "/cdy",
        },
        {
          name: "专场活动",
          path: "/recruit",
        },
        {
          name: "新上雇主",
          path: "/employer",
        },
        {
          name: "新发职位",
          path: "/positions",
        },
      ],
      showMenu2: false,
      actions2: [
        {
          name: "AI匹配",
          path: "/aiMatch",
        },
        {
          name: "PA派单",
          path: "/pa",
        },
        {
          name: "我的订阅",
          path: "/subscribe",
        },
        {
          name: "我的订单",
          path: "/order",
        },
      ],
    };
  },
  watch: {
    $route() {
      this.link = this.$route.path;
      if (this.$route.path != "/") {
        if (/aiMatch|order/.test(this.$route.path)) {
          if (this.getUserInfo._loadedUserInfo) return;
          //需要调用userinfo的路由
          console.log(123);
          this.$store.dispatch("comp/COMP_USERINFO");
        }
      }
    },
    postLoading(n) {
      if (n) {
        Toast.loading({
          mask: false,
          className: "post-loading-toast",
          duration: 0, //请求结束db里clear 或者报错 覆盖掉
          loadingType: "spinner",
        });
      }
    },
  },
  computed: {
    ...mapState({
      postLoading: (state) => state.comp.postLoading || false,
      getUserInfo: (state) => state.comp.userInfo || {},
      wxShare: (state) => state.comp.share || {},
      showApp: (state) => state.comp.showApp || false,
    }),
  },
  components: {},
  methods: {
    onSelect(item) {
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.showMenu1 = false;
      this.showMenu2 = false;
      this.$router.push(item.path);
    },
  },
  created() {
    this.$store.dispatch("comp/COMP_CITIES");

    let isWeiXin = () => {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    };
    if (isWeiXin()) {
      this.isWeiXin = true;
      this.$store.dispatch("comp/WX_SHARE");
    } else {
      this.isWeiXin = false;
    }
  },
};
</script>
